import { ObservableFromFetch } from "../ObservableFromFetch"
import GovPoolSelection from "./GovPoolModel/GovPoolSelection"

export function GovPoolSelectionGet(dateSelectedID: number) {
  return ObservableFromFetch<GovPoolSelection>("GovPool/GovPoolSelection?dateSelectedID=" + dateSelectedID)
}

